export const ChatIcon = (color = '', className = '') => (
  <svg
    width='28'
    height='28'
    className={className}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M26 18C26 18.7072 25.719 19.3855 25.219 19.8856C24.7189 20.3857 24.0406 20.6667 23.3333 20.6667H7.33333L2 26V4.66667C2 3.95942 2.28095 3.28115 2.78105 2.78105C3.28115 2.28095 3.95942 2 4.66667 2H23.3333C24.0406 2 24.7189 2.28095 25.219 2.78105C25.719 3.28115 26 3.95942 26 4.66667V18Z'
      stroke={color}
      stroke-width='2.66667'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const MessageIcon = (color = '', className = '') => (
  <svg
    width='30'
    height='24'
    className={className}
    viewBox='0 0 30 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.1886 0H4.44504C3.26614 0 2.13553 0.468316 1.30192 1.30192C0.468316 2.13553 0 3.26614 0 4.44504V19.2618C0 20.4407 0.468316 21.5714 1.30192 22.405C2.13553 23.2386 3.26614 23.7069 4.44504 23.7069H25.1886C26.3675 23.7069 27.4981 23.2386 28.3317 22.405C29.1653 21.5714 29.6336 20.4407 29.6336 19.2618V4.44504C29.6336 3.26614 29.1653 2.13553 28.3317 1.30192C27.4981 0.468316 26.3675 0 25.1886 0ZM4.44504 2.96336H25.1886C25.5815 2.96336 25.9584 3.11947 26.2363 3.39734C26.5141 3.6752 26.6702 4.05208 26.6702 4.44504L14.8168 11.6756L2.96336 4.44504C2.96336 4.05208 3.11947 3.6752 3.39734 3.39734C3.6752 3.11947 4.05207 2.96336 4.44504 2.96336ZM26.6702 19.2618C26.6702 19.6548 26.5141 20.0317 26.2363 20.3096C25.9584 20.5874 25.5815 20.7435 25.1886 20.7435H4.44504C4.05207 20.7435 3.6752 20.5874 3.39734 20.3096C3.11947 20.0317 2.96336 19.6548 2.96336 19.2618V7.82327L14.0463 14.5946C14.2716 14.7246 14.5271 14.7931 14.7872 14.7931C15.0473 14.7931 15.3028 14.7246 15.528 14.5946L26.6702 7.82327V19.2618Z'
      fill={color ? color : '#0D0D0D'}
    />
  </svg>
);
